module.exports = __webpack_public_path__ + "static/img/avatar.608c071e.png";